// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TooltipPresentationProps } from "@werner/MobiusOverrides/Tooltip/Tooltip";
import ContextualHelp from "@werner/XDL/Icons/ContextualHelp";
import { xBaseTheme } from "@werner/XDL/types";
import { color, getSystemColor } from "@werner/XDL/Utilities";
import { css } from "styled-components";

export const breadcrumbsTooltipStyles = {
    tooltipContent: {
        css: css`
            background-color: ${color("common.white")};
            box-shadow: 0 0 15px 0 ${color("primary", 0.15)};
            padding: 22px;
            max-width: 300px;
            border: 1px solid ${color("primary", 0.05)};
            border-radius: 0;
            min-width: 140px;
            background-color: ${color("common.white")};
        `,
    },
    tooltipArrow: {
        fill: getSystemColor("common.white"),
        stroke: `${getSystemColor("common.white")}`,
    },
};

export default {
    defaultProps: {
        mergeCss: true,
        extendedStyles: {
            tooltipContent: {
                css: css`
                    background-color: ${color("common.white")};
                    box-shadow: 0 0 15px 0 ${color("primary", 0.15)};
                    padding: 22px;
                    max-width: 300px;
                    border: 1px solid ${color("primary", 0.05)};
                    border-radius: 0;
                    min-width: 140px;
                    background-color: ${color("common.white")};
                `,
            },
            tooltipArrow: {
                fill: getSystemColor("common.white"),
                stroke: `${getSystemColor("common.white")}`,
            },
            triggerWrapper: {
                css: css`
                    display: inline-flex;
                    vertical-align: middle;
                    margin-left: 5px;
                `,
            },
        },
        iconProps: {
            src: ContextualHelp,
            size: 16,
            color: "common.ui3",
            css: css``,
        },
        typographyProps: {
            size: 15,
            color: "text.main",
            weight: 400,

            css: css`
                letter-spacing: 0;
                line-height: 18px;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    } as TooltipPresentationProps,
} as xBaseTheme["tooltip"];
